// extracted by mini-css-extract-plugin
export default {"loading":"houseCard_loading__uxHNJ","pcWrap":"houseCard_pcWrap__Nq8ob"};